import { Typography } from "antd";
import { StyledSidebarFooter } from "./index.styled";
import { APP_VERSION } from "@lib/constants/AppConst";
import { useTypedSelector } from "@lib/redux";

export default function AdminSidebarFooter() {
  const { sidebar } = useTypedSelector((state) => state.screen);

  const copyableText = `App Version: ${APP_VERSION}`;

  return (
    <StyledSidebarFooter collapsed={sidebar.collapsed}>
      <Typography.Text copyable={{ text: copyableText }}>
        {sidebar?.collapsed ? `v: ${APP_VERSION}` : `Version : ${APP_VERSION}`}
      </Typography.Text>
    </StyledSidebarFooter>
  );
}
